import { render, staticRenderFns } from "./KinderverwaltungAnwesendHeuteBis.vue?vue&type=template&id=3b92e024"
import script from "./KinderverwaltungAnwesendHeuteBis.vue?vue&type=script&lang=js"
export * from "./KinderverwaltungAnwesendHeuteBis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports